import { render, staticRenderFns } from "./UsersOfCatalog.vue?vue&type=template&id=5f8cb6eb&scoped=true&"
import script from "./UsersOfCatalog.vue?vue&type=script&lang=js&"
export * from "./UsersOfCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8cb6eb",
  null
  
)

export default component.exports